import { render, staticRenderFns } from "./LeadsTab.vue?vue&type=template&id=3120a126&"
import script from "./LeadsTab.vue?vue&type=script&lang=js&"
export * from "./LeadsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports